<template>
     <div class="editor_index">
        <Toolbar
            class="editor_header"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            class="editor_content"
            v-model="html"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
            @onChange="onChange"
        />
    </div>
</template>
<script>
import Vue from 'vue'
import {Editor,Toolbar} from '@wangeditor/editor-for-vue'
export default Vue.extend({
    components:{Editor,Toolbar},
    props:{
        editorShow:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            editor: null,
            html: '',
            toolbarConfig: { },
            editorConfig: { 
                autoFocus:false,
                placeholder: '请输入公告内容...' ,
                withCredentials:true,
                MENU_CONF:{
                    //图片上传
                    uploadImage:{
                        fieldName:'file',
                        maxFileSize: 6 * 1024 * 1024, //
                        maxNumberOfFiles: 200,
                        server:`/htapi/file/file/upload`,
                        customInsert:(res,insertFn)=>{
                            insertFn(`https://htpipe.thhy-tj.com/${res.data}`) 
                        }
                        // headers:{
                        //     token:sessionStorage.getItem('token')
                        // }
                    }
                }
            },
            mode: 'default', // or 'simple'或default
        }
    },
    mounted() {
    },
    watch:{
        editorShow:{
            handler(val){
                this.$nextTick(() => {
                    this.html = val
                })
            },
            deep: true,
            immediate: true
        },
        html(value) {
            this.$emit('update:editorShow', value);
        }
    },
    methods:{
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
        onChange(editor){
            // this.$emit('editorCreate',editor.getHtml())
            this.$emit('editorCreate',editor)
        },
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
})
</script>
<style scoped lang="scss">
.editor_index{
    margin-top: 15px;
    border: 1px solid #1B428F;

    .editor_header{
        border-bottom: 1px solid #ccc
    }

    .editor_content{
        height: 300px;
        overflow-y: hidden;

        /deep/.w-e-text-container{
            background-color: #fff;
            color: #000;
        }
    }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>